export const initialErrors = {
  image: null,
  title: null,
  description: null,
  price: null,
  limit: null,
  state: null,
  position: null,
};

export const cartGiftsTableHead = [
  {
    id: 'image',
    numeric: false,
    label: 'Image',
  },
  {
    id: 'title',
    numeric: false,
    label: 'Title',
  },
  {
    id: 'description',
    numeric: false,
    label: 'Description',
  },
  {
    id: 'price',
    numeric: true,
    label: 'Price',
  },
  {
    id: 'limit',
    numeric: true,
    label: 'Limit',
  },
  {
    id: 'state',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'position',
    numeric: true,
    label: 'Position',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'Created At',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

export const stateOptions = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

export type initialErrorsType = typeof initialErrors; 